__turbopack_context__.v({
  "denomination": "KoNEfa_denomination",
  "rounded": "KoNEfa_rounded",
  "textInput": "KoNEfa_textInput",
  "textInputWrapper": "KoNEfa_textInputWrapper",
  "underlined": "KoNEfa_underlined",
});
